import React, {  } from 'react'
import classes from './About.module.css'
import { animated, useSpring, useChain, config, useSpringRef } from 'react-spring'
import Card from './Card'

const About = () => {
  //springs and refs
  const l1ref = useSpringRef()
  const l2ref = useSpringRef()
  const l3ref = useSpringRef()
  const l4ref = useSpringRef()
  const l5ref = useSpringRef()
  const emojiref = useSpringRef()
  const nameRef = useSpringRef()

  const l1Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l1ref,
  })

  const nameSpring = useSpring({
    from: { transform: 'translateX(-50px)', opacity: 0 },
    to: { transform: 'translateX(0px)', opacity: 1 },
    ref: nameRef,
  })
  const l2Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l2ref,
  })
  const l3Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l3ref,
  })
  const l4Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l4ref,
  })
  const l5Spring = useSpring({
    from: { transform: 'translateY(50px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
    ref: l5ref,
  })

  const emojiSpring = useSpring({
    from: { opacity: 0, transform: 'rotate(50deg)' },
    to: { opacity: 1, transform: 'rotate(0deg)' },
    ref: emojiref,
    config: config.wobbly,
  })

  //card refs and springs
  const c1ref = useSpringRef()
  const c2ref = useSpringRef()
  const c3ref = useSpringRef()
  const c4ref = useSpringRef()
  const c5ref = useSpringRef()
  const c6ref = useSpringRef()
  const c7ref = useSpringRef()
  const c8ref = useSpringRef()
  const c9ref = useSpringRef()

  useChain(
    [
      l1ref,
      nameRef,
      l2ref,
      l3ref,
      l4ref,
      l5ref,
      emojiref,
      c1ref,
      c2ref,
      c3ref,
      c4ref,
      c5ref,
      c6ref,
      c7ref,
      c8ref,
      c9ref,
    ],
    [0, 0.1, 0.2, 0.4, 0.6, 0.8, 1.1, 0.4, 0.6, 0.8, 0.2, 0.4, 0.6, 0, 0.2, 0.4]
  )

  return (
    <div className={classes.container}>
      <animated.h1 className={classes.header}>
        <animated.span style={l1Spring}>
          Hi, I’m{' '}
          <animated.span className={classes.green} style={nameSpring}>
            Abdul Muhaimin
          </animated.span>
        </animated.span>
        <br />
        <animated.span style={l2Spring}>I’m a fullstack web,</animated.span>
        <br />
        <animated.span style={l3Spring}>mobile app developer</animated.span>
        <br />
        <animated.span style={l4Spring}>and I love what i do.</animated.span>
        <br />
        <animated.span className={classes.subhead} style={l5Spring}>
          Technologies i use
        </animated.span>
        <animated.span style={{ paddingLeft: '0.5rem', ...emojiSpring }}>
          👉
        </animated.span>
      </animated.h1>
      <animated.div className={classes.techs}>
        <Card springRef={c1ref}>
          <svg
            width="74"
            height="74"
            viewBox="0 0 74 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37 41.625C35.7734 41.625 34.597 41.1377 33.7296 40.2704C32.8623 39.403 32.375 38.2266 32.375 37C32.375 35.7734 32.8623 34.597 33.7296 33.7296C34.597 32.8623 35.7734 32.375 37 32.375C38.2266 32.375 39.403 32.8623 40.2704 33.7296C41.1377 34.597 41.625 35.7734 41.625 37C41.625 38.2266 41.1377 39.403 40.2704 40.2704C39.403 41.1377 38.2266 41.625 37 41.625ZM35.372 50.8565C35.9116 51.504 36.4542 52.133 37 52.7343C37.5457 52.133 38.0884 51.5071 38.628 50.8565C37.5428 50.8796 36.4572 50.8796 35.372 50.8565ZM29.2208 50.4711C26.8529 50.2247 24.5008 49.8459 22.1753 49.3364C21.9441 50.4156 21.7683 51.4639 21.6512 52.4691C21.0653 57.35 21.8824 60.3162 23.125 61.0315C24.3676 61.7499 27.343 60.9729 31.2804 58.0284C32.0913 57.4209 32.9084 56.7457 33.7286 56.0088C32.1237 54.2485 30.6187 52.3997 29.2208 50.4711ZM51.8247 49.3364C49.6139 49.8298 47.2521 50.2121 44.7792 50.4711C43.3813 52.3997 41.8763 54.2485 40.2714 56.0088C41.0916 56.7488 41.9087 57.4209 42.7196 58.0284C46.657 60.9729 49.6324 61.7499 50.875 61.0315C52.1176 60.3162 52.9316 57.35 52.3519 52.4691C52.2247 51.4175 52.0498 50.3722 51.8277 49.3364H51.8247ZM56.2955 48.1432C58.0746 56.2801 57.1403 62.7582 53.1875 65.0399C49.2347 67.3215 43.1574 64.8919 37 59.2833C30.8426 64.8919 24.7653 67.3184 20.8125 65.0368C16.8597 62.7551 15.9254 56.2801 17.7014 48.1401C9.76492 45.6149 4.625 41.5634 4.625 37C4.625 32.4367 9.76492 28.3883 17.7014 25.8568C15.9254 17.7199 16.8597 11.2418 20.8125 8.96018C24.7653 6.67851 30.8426 9.10818 37 14.7168C43.1574 9.10818 49.2347 6.68159 53.1875 8.96326C57.1403 11.2449 58.0746 17.7199 56.2986 25.8599C64.2351 28.3852 69.375 32.4367 69.375 37C69.375 41.5634 64.2351 45.6118 56.2986 48.1432H56.2955ZM33.7255 17.9913C32.9414 17.2815 32.1255 16.6076 31.2804 15.9717C27.343 13.0271 24.3676 12.2501 23.125 12.9685C21.8824 13.6838 21.0684 16.65 21.6481 21.5309C21.7714 22.5392 21.9441 23.5844 22.1722 24.6636C24.4987 24.154 26.8519 23.7752 29.2208 23.5289C30.6853 21.5155 32.1962 19.6624 33.7286 17.9913H33.7255ZM44.7792 23.5289C47.2521 23.7879 49.6139 24.1733 51.8247 24.6636C52.0559 23.5844 52.2317 22.5361 52.3488 21.5309C52.9347 16.65 52.1176 13.6838 50.875 12.9685C49.6324 12.2501 46.657 13.0271 42.7196 15.9717C41.8734 16.6075 41.0565 17.2814 40.2714 17.9913C41.8038 19.6624 43.3147 21.5155 44.7792 23.5289ZM38.628 23.1435C38.0884 22.496 37.5457 21.867 37 21.2658C36.4542 21.867 35.9116 22.4929 35.372 23.1435C36.4572 23.1205 37.5428 23.1205 38.628 23.1435ZM25.8137 45.3374C25.2511 44.4096 24.7083 43.47 24.1857 42.5192C23.8927 43.3116 23.6214 44.0917 23.3747 44.8656C24.1672 45.0383 24.9812 45.1955 25.8106 45.3374H25.8137ZM31.7707 46.0589C35.2521 46.3174 38.7479 46.3174 42.2293 46.0589C44.194 43.1727 45.942 40.1448 47.4587 37C45.942 33.8553 44.194 30.8273 42.2293 27.9412C38.7479 27.6826 35.2521 27.6826 31.7707 27.9412C29.806 30.8273 28.058 33.8553 26.5413 37C28.058 40.1448 29.806 43.1727 31.7707 46.0589ZM49.8143 31.4808C50.1073 30.6884 50.3786 29.9083 50.6253 29.1344C49.8169 28.959 49.0048 28.8017 48.1894 28.6627C48.7509 29.5905 49.2927 30.5301 49.8143 31.4808ZM18.9008 30.3308C17.8525 30.6699 16.8597 31.0399 15.9285 31.4408C11.4114 33.3771 9.25 35.5663 9.25 37C9.25 38.4338 11.4083 40.6229 15.9285 42.5593C16.8597 42.9601 17.8525 43.3301 18.9008 43.6693C19.5853 41.5109 20.4332 39.2724 21.4446 37C20.4728 34.8262 19.6235 32.5996 18.9008 30.3308ZM23.3717 29.1344C23.6214 29.9053 23.8927 30.6884 24.1857 31.4778C24.7084 30.528 25.2512 29.5894 25.8137 28.6627C24.9812 28.8045 24.1672 28.9618 23.3747 29.1344H23.3717ZM55.0992 43.6693C56.1475 43.3301 57.1403 42.9601 58.0715 42.5593C62.5886 40.6229 64.75 38.4338 64.75 37C64.75 35.5663 62.5917 33.3771 58.0715 31.4408C57.098 31.0261 56.1062 30.6557 55.0992 30.3308C54.4147 32.4891 53.5667 34.7276 52.5554 37C53.5667 39.2724 54.4147 41.5079 55.0992 43.6693ZM50.6283 44.8656C50.3786 44.0948 50.1073 43.3116 49.8143 42.5223C49.2916 43.472 48.7488 44.4106 48.1863 45.3374C49.0188 45.1955 49.8328 45.0383 50.6253 44.8656H50.6283Z"
              fill="#5ED1E0"
            />
          </svg>
          <p>ReactJS</p>
        </Card>
        <Card springRef={c2ref}>
          <svg
            width="74"
            height="74"
            viewBox="0 0 74 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37 41.625C35.7734 41.625 34.597 41.1377 33.7296 40.2704C32.8623 39.403 32.375 38.2266 32.375 37C32.375 35.7734 32.8623 34.597 33.7296 33.7296C34.597 32.8623 35.7734 32.375 37 32.375C38.2266 32.375 39.403 32.8623 40.2704 33.7296C41.1377 34.597 41.625 35.7734 41.625 37C41.625 38.2266 41.1377 39.403 40.2704 40.2704C39.403 41.1377 38.2266 41.625 37 41.625ZM35.372 50.8565C35.9116 51.504 36.4542 52.133 37 52.7343C37.5457 52.133 38.0884 51.5071 38.628 50.8565C37.5428 50.8796 36.4572 50.8796 35.372 50.8565ZM29.2208 50.4711C26.8529 50.2247 24.5008 49.8459 22.1753 49.3364C21.9441 50.4156 21.7683 51.4639 21.6512 52.4691C21.0653 57.35 21.8824 60.3162 23.125 61.0315C24.3676 61.7499 27.343 60.9729 31.2804 58.0284C32.0913 57.4209 32.9084 56.7457 33.7286 56.0088C32.1237 54.2485 30.6187 52.3997 29.2208 50.4711ZM51.8247 49.3364C49.6139 49.8298 47.2521 50.2121 44.7792 50.4711C43.3813 52.3997 41.8763 54.2485 40.2714 56.0088C41.0916 56.7488 41.9087 57.4209 42.7196 58.0284C46.657 60.9729 49.6324 61.7499 50.875 61.0315C52.1176 60.3162 52.9316 57.35 52.3519 52.4691C52.2247 51.4175 52.0498 50.3722 51.8277 49.3364H51.8247ZM56.2955 48.1432C58.0746 56.2801 57.1403 62.7582 53.1875 65.0399C49.2347 67.3215 43.1574 64.8919 37 59.2833C30.8426 64.8919 24.7653 67.3184 20.8125 65.0368C16.8597 62.7551 15.9254 56.2801 17.7014 48.1401C9.76492 45.6149 4.625 41.5634 4.625 37C4.625 32.4367 9.76492 28.3883 17.7014 25.8568C15.9254 17.7199 16.8597 11.2418 20.8125 8.96018C24.7653 6.67851 30.8426 9.10818 37 14.7168C43.1574 9.10818 49.2347 6.68159 53.1875 8.96326C57.1403 11.2449 58.0746 17.7199 56.2986 25.8599C64.2351 28.3852 69.375 32.4367 69.375 37C69.375 41.5634 64.2351 45.6118 56.2986 48.1432H56.2955ZM33.7255 17.9913C32.9414 17.2815 32.1255 16.6076 31.2804 15.9717C27.343 13.0271 24.3676 12.2501 23.125 12.9685C21.8824 13.6838 21.0684 16.65 21.6481 21.5309C21.7714 22.5392 21.9441 23.5844 22.1722 24.6636C24.4987 24.154 26.8519 23.7752 29.2208 23.5289C30.6853 21.5155 32.1962 19.6624 33.7286 17.9913H33.7255ZM44.7792 23.5289C47.2521 23.7879 49.6139 24.1733 51.8247 24.6636C52.0559 23.5844 52.2317 22.5361 52.3488 21.5309C52.9347 16.65 52.1176 13.6838 50.875 12.9685C49.6324 12.2501 46.657 13.0271 42.7196 15.9717C41.8734 16.6075 41.0565 17.2814 40.2714 17.9913C41.8038 19.6624 43.3147 21.5155 44.7792 23.5289ZM38.628 23.1435C38.0884 22.496 37.5457 21.867 37 21.2658C36.4542 21.867 35.9116 22.4929 35.372 23.1435C36.4572 23.1205 37.5428 23.1205 38.628 23.1435ZM25.8137 45.3374C25.2511 44.4096 24.7083 43.47 24.1857 42.5192C23.8927 43.3116 23.6214 44.0917 23.3747 44.8656C24.1672 45.0383 24.9812 45.1955 25.8106 45.3374H25.8137ZM31.7707 46.0589C35.2521 46.3174 38.7479 46.3174 42.2293 46.0589C44.194 43.1727 45.942 40.1448 47.4587 37C45.942 33.8553 44.194 30.8273 42.2293 27.9412C38.7479 27.6826 35.2521 27.6826 31.7707 27.9412C29.806 30.8273 28.058 33.8553 26.5413 37C28.058 40.1448 29.806 43.1727 31.7707 46.0589ZM49.8143 31.4808C50.1073 30.6884 50.3786 29.9083 50.6253 29.1344C49.8169 28.959 49.0048 28.8017 48.1894 28.6627C48.7509 29.5905 49.2927 30.5301 49.8143 31.4808ZM18.9008 30.3308C17.8525 30.6699 16.8597 31.0399 15.9285 31.4408C11.4114 33.3771 9.25 35.5663 9.25 37C9.25 38.4338 11.4083 40.6229 15.9285 42.5593C16.8597 42.9601 17.8525 43.3301 18.9008 43.6693C19.5853 41.5109 20.4332 39.2724 21.4446 37C20.4728 34.8262 19.6235 32.5996 18.9008 30.3308ZM23.3717 29.1344C23.6214 29.9053 23.8927 30.6884 24.1857 31.4778C24.7084 30.528 25.2512 29.5894 25.8137 28.6627C24.9812 28.8045 24.1672 28.9618 23.3747 29.1344H23.3717ZM55.0992 43.6693C56.1475 43.3301 57.1403 42.9601 58.0715 42.5593C62.5886 40.6229 64.75 38.4338 64.75 37C64.75 35.5663 62.5917 33.3771 58.0715 31.4408C57.098 31.0261 56.1062 30.6557 55.0992 30.3308C54.4147 32.4891 53.5667 34.7276 52.5554 37C53.5667 39.2724 54.4147 41.5079 55.0992 43.6693ZM50.6283 44.8656C50.3786 44.0948 50.1073 43.3116 49.8143 42.5223C49.2916 43.472 48.7488 44.4106 48.1863 45.3374C49.0188 45.1955 49.8328 45.0383 50.6253 44.8656H50.6283Z"
              fill="#007383"
            />
          </svg>
          <p>React Native</p>
        </Card>
        <Card springRef={c3ref}>
          <svg
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M70 54.2391C67.4538 54.8866 65.8787 54.2675 64.4656 52.1456L54.4162 38.2419L52.9637 36.3169L41.2278 52.1916C39.8869 54.1012 38.4803 54.9325 35.9778 54.2566L51.0059 34.0834L37.0147 15.8616C39.4209 15.3934 41.0834 15.6319 42.56 17.7866L52.9834 31.8631L63.4834 17.8631C64.8288 15.9534 66.2747 15.2272 68.6897 15.9316L63.2647 23.1241L55.9147 32.6944C55.0397 33.7881 55.16 34.5362 55.965 35.5928L70 54.2391ZM0.0175 33.7466L1.24687 27.7003C4.59375 15.7347 18.3094 10.7625 27.7681 18.1562C33.2959 22.505 34.6697 28.6562 34.3963 35.5469H3.2375C2.76938 47.95 11.6966 55.4356 23.0781 51.6162C27.0703 50.2753 29.4219 47.1494 30.5987 43.2381C31.1959 41.2781 32.1847 40.9719 34.0266 41.5319C33.0859 46.4231 30.9641 50.5094 26.4797 53.0666C19.7794 56.8947 10.2156 55.6566 5.18437 50.3366C2.1875 47.25 0.949375 43.3387 0.39375 39.1562C0.30625 38.465 0.13125 37.8066 0 37.1437C0.0116667 36.0121 0.0175 34.8804 0.0175 33.7487V33.7466ZM3.29438 32.9153H31.4519C31.2681 23.9466 25.6834 17.5766 18.0513 17.5219C9.67313 17.4562 3.6575 23.6753 3.29438 32.9153Z"
              fill="black"
            />
          </svg>
          <p>ExpressJS</p>
        </Card>
        <Card springRef={c4ref}>
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0)">
              <path
                d="M31.8 0.174L33.508 3.382C33.892 3.974 34.308 4.498 34.798 4.986C36.228 6.416 37.586 7.914 38.806 9.518C41.7 13.318 43.652 17.538 45.046 22.102C45.882 24.89 46.336 27.75 46.37 30.642C46.51 39.288 43.546 46.712 37.57 52.882C36.594 53.858 35.55 54.762 34.43 55.566C33.838 55.566 33.558 55.112 33.314 54.694C32.86 53.928 32.582 53.054 32.442 52.184C32.232 51.138 32.094 50.092 32.162 49.012V48.524C32.114 48.42 31.592 0.42 31.8 0.174Z"
                fill="#599636"
              />
              <path
                d="M31.8 0.0679992C31.73 -0.0720008 31.66 0.0339992 31.59 0.101999C31.624 0.801999 31.38 1.426 30.998 2.022C30.578 2.614 30.022 3.068 29.464 3.556C26.364 6.24 23.924 9.482 21.97 13.108C19.37 17.988 18.03 23.218 17.65 28.724C17.476 30.71 18.278 37.718 18.904 39.74C20.612 45.108 23.68 49.606 27.654 53.51C28.63 54.45 29.674 55.322 30.754 56.16C31.068 56.16 31.102 55.88 31.174 55.672C31.3117 55.2269 31.4166 54.7724 31.488 54.312L32.188 49.084L31.8 0.0679992Z"
                fill="#6CAC48"
              />
              <path
                d="M33.508 57.69C33.578 56.89 33.962 56.226 34.38 55.564C33.96 55.39 33.648 55.044 33.404 54.658C33.194 54.31 33.02 53.892 32.884 53.508C32.396 52.044 32.292 50.508 32.152 49.012V48.106C31.978 48.246 31.942 49.43 31.942 49.606C31.8403 51.1872 31.6304 52.7595 31.314 54.312C31.21 54.94 31.14 55.566 30.754 56.124C30.754 56.194 30.754 56.264 30.788 56.368C31.416 58.216 31.588 60.098 31.694 62.016V62.716C31.694 63.552 31.66 63.376 32.354 63.656C32.634 63.76 32.946 63.796 33.226 64.004C33.436 64.004 33.47 63.83 33.47 63.69L33.366 62.54V59.332C33.332 58.772 33.436 58.216 33.506 57.692L33.508 57.69Z"
                fill="#C2BFBF"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="64" height="64" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p>MongoDB</p>
        </Card>
        <Card springRef={c5ref}>
          <svg
            height="50"
            viewBox="0 0 148 90" // style="transform:translateX(4%);shape-rendering:auto"
          >
            <path
              d="M34.992 23.495h27.855v2.219H37.546v16.699h23.792v2.219H37.546v18.334h25.591v2.219H34.992v-41.69zm30.35 0h2.96l13.115 18.334 13.405-18.334L113.055.207 83.1 43.756l15.436 21.429H95.46L81.417 45.683 67.316 65.185h-3.018L79.85 43.756 65.343 23.495zm34.297 2.219v-2.219h31.742v2.219h-14.623v39.47h-2.554v-39.47H99.64zM.145 23.495h3.192l44.011 66.003L29.16 65.185 2.814 26.648l-.116 38.537H.145v-41.69zm130.98 38.801c-.523 0-.914-.405-.914-.928 0-.524.391-.929.913-.929.528 0 .913.405.913.929 0 .523-.385.928-.913.928zm2.508-2.443H135c.019.742.56 1.24 1.354 1.24.888 0 1.391-.535 1.391-1.539v-6.356h1.391v6.362c0 1.808-1.043 2.849-2.77 2.849-1.62 0-2.732-1.01-2.732-2.556zm7.322-.08h1.379c.118.853.95 1.395 2.149 1.395 1.117 0 1.937-.58 1.937-1.377 0-.685-.521-1.097-1.708-1.377l-1.155-.28c-1.62-.38-2.36-1.166-2.36-2.487 0-1.602 1.304-2.668 3.26-2.668 1.82 0 3.15 1.066 3.23 2.58h-1.354c-.13-.828-.85-1.346-1.894-1.346-1.1 0-1.832.53-1.832 1.34 0 .642.472 1.01 1.64 1.284l.987.243c1.838.43 2.596 1.178 2.596 2.53 0 1.72-1.33 2.799-3.453 2.799-1.987 0-3.323-1.029-3.422-2.637z"
              fill="#000"
              fillRule="nonzero"
            ></path>
          </svg>
          <p>NextJS</p>
        </Card>
        <Card springRef={c6ref}>
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M56.7226 54.4725L28.6628 62.838C28.4673 62.8973 28.2598 62.9048 28.0605 62.8599C27.8612 62.815 27.677 62.7192 27.5258 62.5818C27.3746 62.4445 27.2616 62.2702 27.1978 62.0762C27.1341 61.8821 27.1218 61.6748 27.1621 61.4745L37.1881 13.0747C37.2305 12.877 37.3338 12.6976 37.4834 12.5616C37.6331 12.4256 37.8216 12.3399 38.0224 12.3166C38.2233 12.2933 38.4264 12.3334 38.6032 12.4315C38.7801 12.5295 38.9217 12.6805 39.0083 12.8632L57.5686 52.6005C57.6518 52.7772 57.6957 52.9698 57.6972 53.1651C57.6987 53.3604 57.6579 53.5537 57.5775 53.7317C57.497 53.9096 57.379 54.068 57.2314 54.1959C57.0838 54.3238 56.9102 54.4182 56.7226 54.4725ZM61.5353 52.497L40.0501 6.48675C39.786 5.91925 39.3723 5.43444 38.8533 5.0844C38.3344 4.73436 37.7299 4.53232 37.1048 4.5C36.4797 4.457 35.8548 4.58739 35.299 4.8768C34.7432 5.16621 34.2781 5.60342 33.9548 6.14025L10.6561 44.208C10.3007 44.7842 10.1158 45.4494 10.123 46.1264C10.1302 46.8033 10.329 47.4644 10.6966 48.033L22.0906 65.8282C22.5199 66.4933 23.1531 67.0013 23.8954 67.2764C24.6377 67.5514 25.4491 67.5785 26.2081 67.3537L59.2831 57.492C59.7826 57.3465 60.2447 57.0944 60.6374 56.7532C61.0302 56.4119 61.3443 55.9896 61.5582 55.5153C61.772 55.041 61.8805 54.5259 61.8762 54.0056C61.8719 53.4853 61.7548 52.9722 61.5331 52.5015L61.5353 52.497Z"
              fill="#0C344B"
            />
          </svg>
          <p>Prisma</p>
        </Card>
        <Card springRef={c7ref}>
          <svg
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.52113 53.3493L6.95447 51.8653L35.5798 2.28667L38.1465 3.77067L9.52113 53.3493Z"
              fill="#E10098"
            />
            <path
              d="M6.36414 47.9033H63.6195V50.8713H6.36414V47.9033Z"
              fill="#E10098"
            />
            <path
              d="M36.1352 66.108L7.49817 49.574L8.98217 47.0073L37.6192 63.5413L36.1352 66.108ZM61.0132 23.0113L32.3738 6.47966L33.8578 3.91299L62.4949 20.447L61.0132 23.0113Z"
              fill="#E10098"
            />
            <path
              d="M8.98913 23.002L7.50513 20.4353L36.1678 3.89667L37.6518 6.46333L8.98913 23.002Z"
              fill="#E10098"
            />
            <path
              d="M60.4859 53.3493L31.8559 3.766L34.4225 2.282L63.0525 51.8653L60.4859 53.3493ZM8.63452 18.466H11.6025V51.534H8.63452V18.466ZM58.3999 18.466H61.3679V51.534H58.3999V18.466Z"
              fill="#E10098"
            />
            <path
              d="M35.6312 64.8503L34.3362 62.6057L59.2445 48.2253L60.5395 50.47L35.6312 64.8503Z"
              fill="#E10098"
            />
            <path
              d="M65.2995 52.5C64.4704 53.9319 63.1075 54.9768 61.5094 55.4059C59.9113 55.8349 58.2084 55.6131 56.7735 54.789C55.3416 53.9598 54.2967 52.5969 53.8676 50.9989C53.4386 49.4008 53.6604 47.6978 54.4845 46.263C55.3137 44.8311 56.6766 43.7861 58.2746 43.3571C59.8727 42.9281 61.5757 43.1499 63.0105 43.974C66.0135 45.7077 67.0332 49.5157 65.2972 52.5H65.2995ZM15.4992 23.7393C14.67 25.1712 13.3071 26.2162 11.7091 26.6452C10.111 27.0742 8.40803 26.8524 6.97319 26.0283C5.54064 25.1992 4.49526 23.8358 4.06619 22.2372C3.63712 20.6386 3.85936 18.935 4.68419 17.5C5.51335 16.0681 6.87624 15.0231 8.47431 14.5941C10.0724 14.1651 11.7754 14.3869 13.2102 15.211C14.6421 16.0402 15.687 17.403 16.1161 19.0011C16.5451 20.5992 16.3233 22.3022 15.4992 23.737V23.7393ZM4.70286 52.5C3.87876 51.0652 3.65693 49.3622 4.08597 47.7641C4.51501 46.166 5.55994 44.8032 6.99186 43.974C8.4267 43.1499 10.1297 42.9281 11.7277 43.3571C13.3258 43.7861 14.6887 44.8311 15.5179 46.263C16.342 47.6978 16.5638 49.4008 16.1347 50.9989C15.7057 52.5969 14.6608 53.9598 13.2289 54.789C10.2259 56.504 6.41553 55.489 4.70286 52.5023V52.5ZM54.5032 23.7417C53.6791 22.3068 53.4573 20.6038 53.8863 19.0058C54.3153 17.4077 55.3603 16.0448 56.7922 15.2157C58.227 14.3916 59.93 14.1697 61.5281 14.5988C63.1262 15.0278 64.489 16.0727 65.3182 17.5047C66.1423 18.9395 66.3641 20.6425 65.9351 22.2405C65.506 23.8386 64.4611 25.2015 63.0292 26.0307C61.5944 26.8548 59.8914 27.0766 58.2933 26.6475C56.6952 26.2185 55.3324 25.1736 54.5032 23.7417ZM35.0012 70C33.7671 70 32.5607 69.634 31.5346 68.9483C30.5085 68.2626 29.7087 67.288 29.2366 66.1478C28.7644 65.0076 28.641 63.7529 28.8819 62.5426C29.1229 61.3322 29.7173 60.2205 30.5901 59.348C31.463 58.4755 32.5749 57.8814 33.7854 57.6409C34.9959 57.4004 36.2505 57.5243 37.3905 57.9969C38.5305 58.4695 39.5048 59.2696 40.1901 60.296C40.8755 61.3223 41.241 62.5289 41.2405 63.763C41.2362 65.4162 40.5774 67.0005 39.4082 68.1693C38.2389 69.3381 36.6544 69.9963 35.0012 70ZM35.0012 12.4787C34.1815 12.4799 33.3696 12.3193 32.6121 12.0062C31.8545 11.6931 31.1662 11.2336 30.5866 10.6539C30.007 10.0743 29.5474 9.38601 29.2343 8.62847C28.9212 7.87092 28.7606 7.05903 28.7619 6.23933C28.7619 4.58486 29.4191 2.99816 30.589 1.82828C31.7589 0.658393 33.3456 0.00115967 35 0.00115967C36.6545 0.00115967 38.2412 0.658393 39.4111 1.82828C40.581 2.99816 41.2382 4.58486 41.2382 6.23933C41.2391 7.05864 41.0784 7.87009 40.7653 8.62721C40.4522 9.38434 39.9928 10.0723 39.4135 10.6516C38.8341 11.2309 38.1462 11.6903 37.3891 12.0034C36.632 12.3166 35.8205 12.4772 35.0012 12.4763"
              fill="#E10098"
            />
          </svg>
          <p>GraphQL</p>
        </Card>
        <Card springRef={c8ref}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
            <path
              fill="#2f406a"
              d="M101.84,41.72V86L64.18,108.32l-.34.31V125.2l.34.32,53-30.64V33.12l-.5-.12-15,8.36.08.36"
            />
            <path
              fill="#2379bd"
              d="M26.4,86.4l37.78,21.92v17.2L10.78,94.76V33.24l.55-.08,14.91,8.67.16.5V86.4"
            />
            <path
              fill="#03afef"
              d="M26.4,42.32,10.78,33.24,64.06,2.48l53.16,30.64-15.38,8.6L64.06,20.16,26.4,42.32"
            />
            <path
              fill="#2f406a"
              d="M63.53,81.33l-.41-.42V64.27l.41-.21.1-.41L77.9,55.33l.44.1V72.58l-14.8,8.76"
            />
            <path
              fill="#2379bd"
              d="M48.48,73.11V55.3l.41,0,14.51,8.45.12.33V81.33L48.48,73.11"
            />
            <path
              fill="#03afef"
              d="M63.29,46.54,48.48,55.3l15.05,8.76,14.8-8.64L63.29,46.54"
            />
            <path
              fill="#2f406a"
              d="M45.11,92.19l-.41-.42V75.13l.41-.21.1-.41,14.27-8.32.44.1V83.43l-14.8,8.76"
            />
            <path
              fill="#2379bd"
              d="M30.06,84V66.16l.41,0L45,74.59l.12.33V92.19L30.06,84"
            />
            <path
              fill="#03afef"
              d="M44.86,57.4l-14.8,8.76,15.05,8.76,14.8-8.64L44.86,57.4"
            />
            <path
              fill="#2f406a"
              d="M83.27,92.6l-.41-.42V75.54l.41-.21.1-.41L97.64,66.6l.44.1V83.84L83.27,92.6"
            />
            <path
              fill="#2379bd"
              d="M68.22,84.38V66.57l.41,0L83.15,75l.12.33V92.6L68.22,84.38"
            />
            <path
              fill="#03afef"
              d="M83,57.81l-14.8,8.76,15.05,8.76,14.8-8.64L83,57.81"
            />
            <path
              fill="#2f406a"
              d="M64.85,103.46l-.41-.42V86.4l.41-.21.1-.41,14.27-8.32.44.1V94.7l-14.8,8.76"
            />
            <path
              fill="#2379bd"
              d="M49.8,95.23V77.43l.41,0,14.51,8.45.12.33v17.27L49.8,95.23"
            />
            <path
              fill="#03afef"
              d="M64.6,68.67,49.8,77.43l15.05,8.76,14.8-8.64L64.6,68.67"
            />
            <path
              fill="#2f406a"
              d="M63.53,57.73l-.41-.42V40.67l.41-.21.1-.41L77.9,31.72l.44.1V49l-14.8,8.76"
            />
            <path
              fill="#2379bd"
              d="M48.48,49.5V31.7l.41,0,14.51,8.45.12.33V57.73L48.48,49.5"
            />
            <path
              fill="#03afef"
              d="M63.29,22.94,48.48,31.7l15.05,8.76,14.8-8.64L63.29,22.94"
            />
            <path
              fill="#2f406a"
              d="M45.11,68.59l-.41-.42V51.53l.41-.21.1-.41,14.27-8.32.44.1V59.83l-14.8,8.76"
            />
            <path
              fill="#2379bd"
              d="M30.06,60.36V42.55l.41,0L45,51l.12.33V68.59L30.06,60.36"
            />
            <path
              fill="#03afef"
              d="M44.86,33.8l-14.8,8.76,15.05,8.76,14.8-8.64L44.86,33.8"
            />
            <path
              fill="#2f406a"
              d="M83.27,69l-.41-.42V51.94l.41-.21.1-.41L97.64,43l.44.1V60.24L83.27,69"
            />
            <path
              fill="#2379bd"
              d="M68.22,60.77V43l.41,0,14.51,8.45.12.33V69L68.22,60.77"
            />
            <path
              fill="#03afef"
              d="M83,34.21,68.22,43l15.05,8.76,14.8-8.64L83,34.21"
            />
            <path
              fill="#2f406a"
              d="M64.85,79.85l-.41-.42V62.79l.41-.21.1-.41,14.27-8.32.44.1V71.09l-14.8,8.76"
            />
            <path
              fill="#2379bd"
              d="M49.8,71.63V53.82l.41,0,14.51,8.45.12.33V79.85L49.8,71.63"
            />
            <path
              fill="#03afef"
              d="M64.6,45.06,49.8,53.82l15.05,8.76,14.8-8.64L64.6,45.06"
            />
          </svg>
          <p>Sequelize</p>
        </Card>
        <Card springRef={c9ref}>
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3417 64C24.1707 64 26.8838 62.8762 28.8842 60.8758C30.8846 58.8754 32.0084 56.1623 32.0084 53.3333V42.6667H21.3417C18.5127 42.6667 15.7996 43.7905 13.7992 45.7908C11.7989 47.7912 10.675 50.5043 10.675 53.3333C10.675 56.1623 11.7989 58.8754 13.7992 60.8758C15.7996 62.8762 18.5127 64 21.3417 64Z"
              fill="#0ACF83"
            />
            <path
              d="M10.675 32C10.675 29.171 11.7989 26.4579 13.7992 24.4575C15.7996 22.4571 18.5127 21.3333 21.3417 21.3333H32.0084V42.6667H21.3417C18.5127 42.6667 15.7996 41.5429 13.7992 39.5425C11.7989 37.5421 10.675 34.829 10.675 32Z"
              fill="#A259FF"
            />
            <path
              d="M10.675 10.6667C10.675 7.83913 11.7977 5.12729 13.7963 3.12714C15.7949 1.12699 18.5059 0.00220901 21.3334 0L32 0V21.3333H21.3417C18.5127 21.3333 15.7996 20.2095 13.7992 18.2091C11.7989 16.2088 10.675 13.4956 10.675 10.6667Z"
              fill="#F24E1E"
            />
            <path
              d="M32.0083 0H42.675C45.5039 0 48.2171 1.12381 50.2174 3.12419C52.2178 5.12458 53.3416 7.83769 53.3416 10.6667C53.3416 13.4956 52.2178 16.2088 50.2174 18.2091C48.2171 20.2095 45.5039 21.3333 42.675 21.3333H32.0083V0Z"
              fill="#FF7262"
            />
            <path
              d="M53.3416 32C53.3416 34.829 52.2178 37.5421 50.2174 39.5425C48.2171 41.5429 45.5039 42.6667 42.675 42.6667C39.846 42.6667 37.1329 41.5429 35.1325 39.5425C33.1321 37.5421 32.0083 34.829 32.0083 32C32.0083 29.171 33.1321 26.4579 35.1325 24.4575C37.1329 22.4571 39.846 21.3333 42.675 21.3333C45.5039 21.3333 48.2171 22.4571 50.2174 24.4575C52.2178 26.4579 53.3416 29.171 53.3416 32Z"
              fill="#1ABCFE"
            />
          </svg>
          <p>Figma</p>
        </Card>
      </animated.div>
    </div>
  )
}

export default About
